// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__HLlV0","title":"Images90_title__1OuRr","images":"Images90_images__33AUY"};